import request from "../request";

/**
 * @param {number} orderId
 * @param {('code' | 'phone' | 'email')} type
 * @param {string} value
 * @return {Promise<{ result: Boolean }>}
 */
export const checkFan = (orderId, type, value) => {
	return request({
		url: `/orders/check-fan`,
		type: "GET",
		data: {
			orderId,
			type,
			value,
		},
	});
};

export const getUserOrders = (date) => {
	return request({
		url: "/orders/get-user-orders",
		type: "GET",
		data: date,
	});
};
